import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { config } from "./firebase-config";
import firebaseTestconfig from "./firebase.testconfig";

const isTestEnvironment = import.meta.env.VITE_NODE_ENV === "test";

const firebaseApp = initializeApp(config);

export const auth = getAuth(firebaseApp);

let fBAnalytics;
if (isTestEnvironment) {
    fBAnalytics = firebaseTestconfig.analytics();
} else {
    fBAnalytics = getAnalytics(firebaseApp);
}

export const analytics = fBAnalytics;

export const rtdb = getDatabase(
    firebaseApp,
    import.meta.env.VITE_FIREBASE_DATABASE_URL
);
